<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title>
        Comment Reports
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <div class="ma-4" id="user-list">
      <v-simple-table>
        <thead>
          <tr>
            <th width="1%"></th>
            <th width="20%" class="text-left">Commented by</th>
            <th width="40%" class="text-left">Comment Content</th>
            <th width="10%" class="text-left">Reported by</th>
            <th class="text-left">Commented on</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <template v-if="reportedComments.data.length">
            <tr v-for="comment in reportedComments.data" :key="comment.id">
              <td>
                <v-avatar class="ma-2" color="grey lighten-2" size="38">
                  <img :src="comment.user.avatar_thumb_url" alt="avatar" />
                </v-avatar>
              </td>
              <td>
                {{ comment.user.full_name }}
              </td>
              <td class="py-4">
                <v-img
                  v-if="comment.image"
                  :aspect-ratio="4 / 3"
                  :src="comment.image.url"
                  :lazy-src="comment.image.thumb_url"
                />
                <div class="mt-4 content quill" v-html="comment.comment"></div>
              </td>
              <td>
                {{ comment.count_unique_reporters }}
                {{
                  comment.count_unique_reporters > 1 ? 'students' : 'student'
                }}
              </td>
              <td>{{ comment.createdAt }}</td>
              <td class="text-right">
                <v-menu>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="viewReports(comment)">
                      <v-list-item-title>View reports</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="deleteComment(comment)">
                      <v-list-item-title>Delete Comment</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <tr v-else>
            <td class="text-center headline grey--text py-10" colspan="6">
              No reports available.
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-overlay absolute :value="loading" opacity="0.1">
        <v-progress-circular indeterminate color="primary" size="64" />
      </v-overlay>
    </div>
    <div v-if="reportedComments.meta.last_page > 1" class="text-center mt-4">
      <v-pagination
        @input="pageChanged"
        :value="reportedComments.meta.current_page"
        :length="reportedComments.meta.last_page"
        :total-visible="10"
        circle
      />
    </div>

    <reports-dialog :comment="selectedComment" v-model="showReportsDialog" />
  </div>
</template>

<script>
import { mdiDotsVertical } from '@mdi/js'
import ReportComment from '@/models/ReportComment'
import Comment from '@/models/Comment'
import ReportsDialog from './Reports'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'

export default {
  name: 'ReportsPage',
  components: {
    ReportsDialog,
    AppBarNavIcon
  },
  data() {
    return {
      loading: false,
      icons: {
        settings: mdiDotsVertical
      },
      showReportsDialog: false,
      selectedComment: null,
      reportedComments: {
        data: [],
        meta: {
          current_page: 1
        }
      }
    }
  },

  methods: {
    pageChanged(page) {
      this.reportedComments.meta.current_page = page
      this.getReports()
    },

    getReports() {
      this.loading = true
      return ReportComment.include('user')
        .orderBy('latest-report')
        .limit(15)
        .page(this.reportedComments.meta.current_page)
        .get()
        .then(response => {
          this.reportedComments = response
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },

    viewReports(comment) {
      this.selectedComment = new Comment(comment)
      this.showReportsDialog = true
    },

    deleteComment(reportedComment) {
      this.$confirm(`Are you sure you want to remove this Comment?`, {
        color: 'primary',
        title: 'Remove Comment'
      }).then(confirm => {
        if (confirm) {
          const comment = new Comment(reportedComment)
          comment
            .delete()
            .then(() => {
              this.reportedComments.meta.current_page = 1
              return this.getReports()
            })
            .then(() => {
              this.$toast('Comment has been successfully removed!', {
                color: 'green'
              })
            })
        }
      })
    }
  },

  created() {
    this.getReports()
  }
}
</script>
